// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function PaypalLogoIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M27.515 11.693A6.974 6.974 0 0 0 24.99 9.67 7 7 0 0 0 18 3h-7.5a2 2 0 0 0-1.94 1.515l-4.5 18A2 2 0 0 0 6 25h3.437l-.375 1.515A2 2 0 0 0 11 29h3.937a2 2 0 0 0 1.938-1.515L18 23h4a7 7 0 0 0 5.517-11.307h-.002ZM6 23l4.5-18H18a5 5 0 0 1 4.912 4.061A7.123 7.123 0 0 0 22 9h-7a2 2 0 0 0-1.941 1.515L9.939 23H6Zm16.875-11.922-.03.135A4.992 4.992 0 0 1 18 15h-4l1-4h7c.293 0 .586.026.875.078Zm3.97 6.134A4.992 4.992 0 0 1 22 21h-4a2 2 0 0 0-1.94 1.515L14.935 27H11l2.5-10H18a6.988 6.988 0 0 0 6.75-5.174c.451.3.852.67 1.185 1.096a4.966 4.966 0 0 1 .912 4.29h-.002Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
